var _path, _rect, _rect2, _g, _path2, _path3, _rect3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect4, _path1, _rect5, _path10, _path11, _rect6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultStrikeZoneImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 196,
    viewBox: "0 0 608 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.661 11.3671C342.934 11.0945 342.934 10.6526 342.661 10.38L338.22 5.93839C337.947 5.66583 337.505 5.66583 337.233 5.93839C336.96 6.21095 336.96 6.65286 337.233 6.92542L341.181 10.8735L337.233 14.8217C336.96 15.0942 336.96 15.5361 337.233 15.8087C337.505 16.0812 337.947 16.0812 338.22 15.8087L342.661 11.3671ZM266.065 10.38C265.792 10.6526 265.792 11.0945 266.065 11.367L270.506 15.8087C270.779 16.0812 271.221 16.0812 271.493 15.8087C271.766 15.5361 271.766 15.0942 271.493 14.8217L267.545 10.8735L271.493 6.92541C271.766 6.65285 271.766 6.21095 271.493 5.93838C271.221 5.66582 270.779 5.66582 270.506 5.93838L266.065 10.38ZM342.168 10.1756L266.558 10.1756L266.558 11.5715L342.168 11.5715L342.168 10.1756Z",
    fill: "#EC691A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "strikezone-width",
    x: 289.597,
    y: 0.547119,
    width: 30.3058,
    height: 20.3265,
    rx: 2.5503,
    fill: "#EC691A"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.393903
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1416_14445",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 152,
    width: 607,
    height: 73
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.850586,
    y: 152.98,
    width: 606.041,
    height: 71.8794,
    fill: "url(#paint0_linear_1416_14445)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1416_14445)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.234 168.299L372.523 212.96H391.409L367.636 168.299H350.234Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.482 212.96L498.464 168.299H515.45L604.322 212.96H582.482Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.482 212.96H388.471L386.166 209.85H576.566L582.482 212.96Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.885 170.656H364.717L362.971 168.299H501.405L505.885 170.656Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.582 168.299L236.293 212.96H217.407L241.18 168.299H258.582Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3348 212.96L110.353 168.299H93.3672L4.49539 212.96H26.3348Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3342 212.96H220.345L222.65 209.85H32.2502L26.3342 212.96Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.932 170.656H244.101L245.846 168.299H107.412L102.932 170.656Z",
    fill: "#414141"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.414 179.307L274.389 178.827H334.956L336.764 179.307L338.398 183.555L304.402 187.443L270.406 183.555L272.414 179.307Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.229 178.827H334.928L336.469 182.826L304.402 186.486L272.335 182.826L274.229 178.827Z",
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "strikezone-middle",
    x: 267.338,
    y: 28.5145,
    width: 74.7452,
    height: 97.1643,
    rx: 0.719378,
    stroke: "#222222",
    strokeWidth: 0.479586
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57294,
    d: "M293.768 29.2063V125.531",
    stroke: "#222222",
    strokeWidth: 0.479586,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57294,
    d: "M317.021 29.2063V125.531",
    stroke: "#222222",
    strokeWidth: 0.479586,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57294,
    d: "M267.607 62.2679H341.812",
    stroke: "#222222",
    strokeWidth: 0.479586,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57294,
    d: "M267.607 91.9258H341.812",
    stroke: "#222222",
    strokeWidth: 0.479586,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184.382 180.918H305.874",
    stroke: "#E0E0E0",
    strokeWidth: 1.29247,
    strokeDasharray: "2.58 5.82"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M228.326 125.342L267.1 125.342",
    stroke: "#E0E0E0",
    strokeWidth: 1.29247,
    strokeDasharray: "2.58 5.82"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "bottom-arrow",
    d: "M305.657 124.848C305.384 124.575 304.942 124.575 304.67 124.848L300.228 129.29C299.955 129.562 299.955 130.004 300.228 130.277C300.5 130.549 300.942 130.549 301.215 130.277L305.163 126.329L309.111 130.277C309.384 130.549 309.826 130.549 310.098 130.277C310.371 130.004 310.371 129.562 310.098 129.29L305.657 124.848ZM304.67 181.67C304.942 181.942 305.384 181.942 305.657 181.67L310.098 177.228C310.371 176.956 310.371 176.514 310.098 176.241C309.826 175.969 309.384 175.969 309.111 176.241L305.163 180.189L301.215 176.241C300.942 175.969 300.501 175.969 300.228 176.241C299.955 176.514 299.955 176.956 300.228 177.228L304.67 181.67ZM304.465 125.342L304.465 181.176L305.861 181.176L305.861 125.342L304.465 125.342Z",
    fill: "#EC691A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "strikezone-height",
    x: 291.01,
    y: 143.76,
    width: 30.3058,
    height: 20.3265,
    rx: 2.5503,
    fill: "#EC691A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "top-bottom-arrow",
    d: "M226.698 27.7985C226.425 27.5259 225.983 27.5259 225.711 27.7985L221.269 32.2401C220.996 32.5127 220.996 32.9546 221.269 33.2271C221.542 33.4997 221.983 33.4997 222.256 33.2271L226.204 29.279L230.152 33.2271C230.425 33.4997 230.867 33.4997 231.139 33.2271C231.412 32.9546 231.412 32.5127 231.139 32.2401L226.698 27.7985ZM225.711 125.721C225.983 125.994 226.425 125.994 226.698 125.721L231.139 121.279C231.412 121.007 231.412 120.565 231.139 120.292C230.867 120.02 230.425 120.02 230.152 120.292L226.204 124.24L222.256 120.292C221.983 120.02 221.542 120.02 221.269 120.292C220.996 120.565 220.996 121.007 221.269 121.279L225.711 125.721ZM225.506 28.292L225.506 125.227L226.902 125.227L226.902 28.292L225.506 28.292Z",
    fill: "#EC691A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "strikezone-inner-height",
    x: 211.987,
    y: 66.7104,
    width: 30.3058,
    height: 20.3265,
    rx: 2.5503,
    fill: "#EC691A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M184.382 28.406L267.1 28.406",
    stroke: "#E0E0E0",
    strokeWidth: 1.29247,
    strokeDasharray: "2.58 5.82"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "top-arrow",
    d: "M184.229 27.9125C183.956 27.6399 183.514 27.6399 183.242 27.9125L178.8 32.3541C178.528 32.6267 178.528 33.0686 178.8 33.3412C179.073 33.6137 179.515 33.6137 179.787 33.3412L183.735 29.393L187.683 33.3412C187.956 33.6137 188.398 33.6137 188.671 33.3412C188.943 33.0686 188.943 32.6267 188.671 32.3541L184.229 27.9125ZM183.242 181.411C183.514 181.684 183.956 181.684 184.229 181.411L188.671 176.97C188.943 176.697 188.943 176.255 188.671 175.983C188.398 175.71 187.956 175.71 187.683 175.983L183.735 179.931L179.787 175.983C179.515 175.71 179.073 175.71 178.8 175.983C178.528 176.255 178.528 176.697 178.8 176.97L183.242 181.411ZM183.037 28.406L183.037 180.918L184.433 180.918L184.433 28.406L183.037 28.406Z",
    fill: "#EC691A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "strikezone-outer-height",
    x: 169.518,
    y: 94.8242,
    width: 30.3058,
    height: 20.3265,
    rx: 2.5503,
    fill: "#EC691A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1416_14445",
    x1: 4.15587,
    y1: 223.579,
    x2: 588.598,
    y2: 223.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514444,
    stopColor: "#E3E3E3",
    stopOpacity: 0.0791357
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultStrikeZoneImage);
export default __webpack_public_path__ + "static/media/defaultStrikeZoneImage.ebb2a83664aebf36a517bbcdb175d6d3.svg";
export { ForwardRef as ReactComponent };